module.exports = __webpack_public_path__ + "img/ttb.353c9fba.svg";